var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_vm._m(0),_c('hr'),_c('p',[_vm._v("您已成功设置密码，请使用新的密码登录")]),_c('button',{on:{"click":_vm.demhlu}},[_vm._v("马上登录")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"find_top"},[_c('ul',[_c('li',[_vm._v("1.验证身份")]),_c('li',[_vm._v("2.修改登录密码")]),_c('li',[_vm._v("3.修改成功")])])])
}]

export { render, staticRenderFns }